export interface TournamentIdentity {
  source?: string | null;
  leagueId?: number | null;
  leagueRoundId?: number | null;
}

// A tournament projected from a closed kolejka has no identity of its own — it
// IS the kolejka. Its page would otherwise be a thinner copy of the round view
// (no signups, no schedule), so send the reader to the round instead. Ingested
// files keep their own page: they carry a file number and a manifest name.
export function roundPathFor(tournament: TournamentIdentity | null): string | null {
  if (!tournament || tournament.source !== 'league') {
    return null;
  }

  const { leagueId, leagueRoundId } = tournament;

  if (typeof leagueId !== 'number' || typeof leagueRoundId !== 'number') {
    return null;
  }

  return `/leagues/${leagueId}/rounds/${leagueRoundId}`;
}
